import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { TvEntryContext } from '../auth/tv-entry-context'
import { tvReturnQueryParams } from '../auth/tv-return-url'

// Device-only UX; backend authorization remains mandatory and independent.
export const tvDeviceGuard: CanActivateFn = (route, state) => {
  if (inject(TvEntryContext).resolve(state.url, route.queryParams['returnUrl']) === 'ISOLATED') return true
  const queryParams = tvReturnQueryParams(route.queryParams['returnUrl'])
  return inject(Router).createUrlTree(['/'], queryParams ? { queryParams } : undefined)
}
